import React, { useEffect, useState } from "react";
import axios from "axios";
import "../style/login.css";
import profile from "../img/login/profile1.svg";
import profile2 from "../img/login/profile2.svg";
import Logo from "../img/logos/logo_webtelco_vertical.svg";
import Logo2 from "../img/logos/logo_webtelco_vertical2.svg";
import { useMediaQuery } from "react-responsive";
import Cookies from "js-cookie";
import ForgotPwd from "./forgot_pwd";
import { Typography, styled, TextField, Button, colors } from "@mui/material";
import md5 from "md5";

const RoundedTextField = styled(TextField)(({ theme }) => ({
  "&.MuiTextField-root": {
    backgroundColor: "transparent !important",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    height: "38px !important",
    backgroundColor: "transparent !important",
    "& input": {
      backgroundColor: "transparent !important",
    },
    "& fieldset": {
      border: "2px solid",
      borderColor: theme.palette.primary.main,
      background: "var(--header-background)",
    },
    "&:hover fieldset": {
      borderColor: theme.palette.secondary.main,
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.secondary.main,
    },
  },
  "& .MuiInputLabel-root": {
    color: theme.palette.primary.dark,
    "&.Mui-focused": {
      color: theme.palette.primary.dark,
    },
    "&.MuiFormLabel-root:hover": {
      color: theme.palette.secondary.main,
    },
  },
  "& .MuiInputLabel-outlined": {
    top: "-9px !important",
    fontSize: "15px",
  },
  "& .MuiInputLabel-shrink": {
    transform: "translate(14px, -2px) scale(0.8)",
  },
  "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active":
    {
      "-webkit-box-shadow": "0 0 0px 1000px transparent inset",
      "background-clip": "content-box !important",
      "background-color": "transparent !important",
      background: "transparent !important",
      color: theme.palette.text.primary,
    },
}));

const RoundedButton = styled(Button)(({ theme }) => ({
  borderRadius: "20px",
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  width: "100%",
  padding: "8px 24px",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: theme.palette.secondary.main,
  },
}));

const Login = (props) => {
  const param = props.param;
  const version = require("../version.json");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const isTabMob = useMediaQuery({ maxWidth: "800px" });
  const [lastLoggedInUser, setLastLoggedInUser] = useState(null);
  const [isImageValid, setIsImageValid] = useState(true);

  const handleImageError = () => {
    setIsImageValid(false);
  };

  document.title = param.webApp + " " + version[0].build;

  const handlerSubmit = async (e) => {
    e.preventDefault();

    try {
      const currentParams = param;
      const { urlService, urls } = currentParams;

      // Normalize URLs array
      let finalUrls = Array.isArray(urls) ? [...urls] : [];

      // Add urlService if it exists and isn't already in the array
      if (urlService && !finalUrls.includes(urlService)) {
        finalUrls.unshift(urlService); // Add to beginning for priority
      }

      // If no URLs available, throw error immediately
      if (finalUrls.length === 0) {
        throw new Error("Aucune URL configurée.");
      }

      let workingUrl = null;
      let response = null;

      // Try each URL until one works
      for (const url of finalUrls) {
        try {
          // console.log(`Trying URL: ${url}`);
          response = await axios({
            method: "POST",
            url: url + "auth.php",
            headers: {
              "content-type": "application/json",
              appID: currentParams.appID,
            },
            data: JSON.stringify({ login: email, password: md5(password) }),
            // timeout: 10000, // REMOVED - no timeout
          });

          // Check HTTP status code first
          if (response.status < 200 || response.status >= 300) {
            //console.log(`URL ${url} returned HTTP ${response.status}`);
            continue; // Try next URL
          }

          // Check for application-level errors
          if (response.data.err) {
            console.log(
              `URL ${url} returned application error:`,
              response.data.err
            );
            // This URL responded but has an application error - continue to next URL
            //continue;
          }

          // If we get here with successful HTTP status AND no application error, this URL works
          workingUrl = url;
          console.log(`SUCCESS with URL: ${url} - breaking loop`);
          break; // This should exit the loop immediately
        } catch (error) {
          // Handle different types of axios errors
          if (error.response) {
            // Server responded with error status (4xx, 5xx)
            console.log(`URL ${url} returned HTTP ${error.response.status}`);
          } else if (error.request) {
            // No response received (network error)
            console.log(`URL ${url} - No response received:`, error.message);
          } else {
            // Request setup error
            console.log(`URL ${url} - Request error:`, error.message);
          }
          // Continue to next URL
        }
      }

      // Check if we found a working URL
      if (!workingUrl) {
        throw new Error("Aucun service disponible.");
      }

      // Success! Save the working URL and user data
      var Gfunc = require("../Gfunc");
      if (response.data?.err) alert(response.data?.err);
      Gfunc.axiosResponseV2(
        response,
        alert,
        (data) => {
          const updatedParams = {
            ...currentParams,
            activeUrl: workingUrl,
            urls: finalUrls,
          };

          localStorage.setItem("build", version[0].build);
          localStorage.setItem("token", data.token);
          localStorage.setItem("isLoged", true);
          localStorage.setItem("name", data.name);
          localStorage.setItem("nickname", data.nickname);
          localStorage.setItem("uid", data.uid);
          localStorage.setItem("param", JSON.stringify(updatedParams));

          Cookies.set(
            "lastLoggedInUser",
            JSON.stringify({
              id: data.uid,
              name: data.name,
              login: email,
            }),
            { expires: 7 }
          );

          window.location = "/";
        },
        () => {}, // setData inutile ici
        {
          showSuccess: false, // login → pas besoin de toast success
        }
      );
    } catch (error) {
      alert(error.message || "Échec de la connexion");
      setEmail("");
      setPassword("");
    }
  };
  useEffect(() => {
    const storedUser = Cookies.get("lastLoggedInUser");
    if (storedUser) {
      const e = JSON.parse(storedUser);
      setLastLoggedInUser(e);
      setEmail(e.login);
    }
  }, []);

  return (
    <div className={true ? "login-page" : "login-page2"}>
      {true ? (
        <div className="login-card">
          <div className="formLogin">
            <div className="profileDiv">
              <img
                id="profile2"
                src={param.app === "1" ? Logo : Logo2}
                alt="Profile"
              />

              {/* <img id="profile" src={profile} alt="Profile" /> */}
              {/* <p>{(lastLoggedInUser) ? lastLoggedInUser.name : "COMPTE"}</p> */}
            </div>
            {/* <div className="webProfile">
                        {
                            lastLoggedInUser ? <div id="userPictureCont">
                                {(isImageValid) && <img id="userPicture" src={param.urlimg + "user/" + lastLoggedInUser.id + ".jpg"} alt="Profile" onError={handleImageError} />
                                }
                            </div> : <div></div>
                        }
                        <div id="profile" >
                            <img src={profile} alt="Profile" />
                            <p id="userName">{(lastLoggedInUser) ? lastLoggedInUser.name : "COMPTE"}</p>
                        </div>
                    </div> */}
            <div id="formMessage">
              {/* <img src={formMessage} alt="Message" /> */}
              <Typography color={"var(--primary-dark)"} variant="h6">
                Veuillez saisir vos identifiants pour vous connecter
              </Typography>
            </div>
            <div>
              <div id="form">
                <form
                  id="formLogin"
                  className="profileDiv"
                  onSubmit={handlerSubmit}
                >
                  {lastLoggedInUser && isImageValid ? (
                    <div className="profileImageDiv">
                      <img
                        id="profile"
                        src={
                          param.urlimg +
                          "profile/" +
                          lastLoggedInUser.id +
                          ".jpg"
                        }
                        alt="Profile"
                        onError={handleImageError}
                      />
                    </div>
                  ) : (
                    <div className="profileImageDiv">
                      <img
                        id="profileEmpty"
                        src={param.app === "1" ? profile : profile2}
                        alt="Profile"
                      />
                    </div>
                  )}
                  <div style={{ display: "grid", gap: "10px", width: "100%" }}>
                    <RoundedTextField
                      autoComplete="off"
                      id="email"
                      label="Login"
                      variant="outlined"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <RoundedTextField
                      autoComplete="new-password"
                      id="password"
                      label="Mot de passe"
                      variant="outlined"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                </form>
                <ForgotPwd param={param} email={email} />
                <div id="buttonDiv">
                  <RoundedButton form="formLogin" type="submit">
                    Connect
                  </RoundedButton>
                </div>
              </div>
            </div>
          </div>
          <div className="logos-grid">
            <div id="logosDiv">
              <div id="startechDiv" />
              <div id="digitartsDiv" />
              <div id="partnerDiv" />
              <div id="partnerArDiv" />
            </div>
          </div>
          <div id="authBottom">
            <span id="copyr">
              {param.webApp} {version[0].build} &copy; {param.copyright}
            </span>
          </div>
        </div>
      ) : (
        <div className="login-card">
          <div className="formLogin">
            <div className="webProfile">
              {/* {
                            lastLoggedInUser ? <div id="userPictureCont">
                                {(isImageValid) && <img id="userPicture" src={param.urlimg + "user/" + lastLoggedInUser.id + ".jpg"} alt="Profile" onError={handleImageError} />
                                }
                            </div> : <div></div>
                        } */}
              <div id="profile">
                <img src={profile} alt="Profile" />
                {/* <p id="userName">{(lastLoggedInUser) ? lastLoggedInUser.name : "COMPTE"}</p> */}
              </div>
            </div>
            <div id="formMessage">
              {/* <img src={formMessage} alt="Message" /> */}
              <Typography color={"var(--primary-dark)"} variant="h6">
                Veuillez saisir vos identifiants pour vous authentifier
              </Typography>
            </div>
            <div>
              <div id="form">
                <form id="formLogin" onSubmit={handlerSubmit}>
                  <RoundedTextField
                    autoComplete="off"
                    id="email"
                    label="Login"
                    variant="outlined"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <RoundedTextField
                    autoComplete="new-password"
                    id="password"
                    label="Mot de passe"
                    variant="outlined"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </form>
                <ForgotPwd param={param} email={email} />
                <div id="buttonDiv">
                  <button id="subo" form="formLogin" type="submit" />
                </div>
              </div>
            </div>
          </div>
          <div className="logos-grid">
            <div id="logosDiv">
              <div id="startechDiv" />
              <div id="digitartsDiv" />
              <div id="partnerDiv" />
              <div id="partnerArDiv" />
            </div>
          </div>
          <div id="authBottom">
            <span id="copyr">
              {param.webApp} {version[0].build} &copy; {param.copyright}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
